export default __webpack_public_path__ + "static/media/newGraphic.af11c4df.png";